module.exports = "//a.spikex.com/sigma/frontend-ssr-web-index/_next/static/images/graph5-a9d35c757de6836dd6786a8d506ddb8d.png";